export default {
  title: 'Niveau de risque de votre patrimoine',
  subtitle: 'En date du {day}',
  subtitleReport: 'En comparaison avec votre profil investisseur',
  legend: {
    investorProfile: 'Votre profil investisseur',
    riskLevel: 'Niveau de risque de votre patrimoine',
  },
}
